<script setup>
import { useGlobeStore } from "@stores/globe";
import ToggleInput from "@components/ToggleInput.vue";

const globeStore = useGlobeStore();
</script>

<template>
    <Transition name="fade" appear>
        <div
            v-if="!globeStore.selectedCountry"
            class="toggle-controls bg-marine-800 hidden flex-col items-center justify-center p-6 lg:flex"
        >
            <div class="flex flex-col gap-3">
                <!-- <ToggleInput
                    label="Show Locked"
                    :model-value="globeStore.showLocked"
                    @update:model-value="globeStore.toggleLocked()"
                /> -->
                <ToggleInput
                    label="Show Routes"
                    :model-value="globeStore.showLines"
                    @update:model-value="globeStore.toggleLines()"
                />
                <ToggleInput
                    label="Auto Rotate"
                    :model-value="globeStore.autoRotateEnabled"
                    @update:model-value="globeStore.toggleAutoRotate()"
                />
            </div>
        </div>
    </Transition>
</template>

<style scoped>
.toggle-controls {
    grid-column: -5 / -1;
    grid-row: -3 / -1;
    z-index: 3;
}
</style>
